export default function ProductShowcase() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="rounded-xl overflow-hidden">
          <div className="relative h-[300px] md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20product%20photography%20flat%20lay%20of%20modern%20casual%20lifestyle%20collection%20on%20warm%20light%20wooden%20surface%2C%20including%20a%20folded%20sage%20green%20sweatshirt%2C%20cream%20canvas%20sneakers%2C%20a%20simple%20tan%20leather%20crossbody%20bag%2C%20a%20minimalist%20silver%20watch%2C%20dark%20tortoiseshell%20sunglasses%2C%20and%20a%20small%20succulent%20plant%2C%20soft%20natural%20sunlight%20from%20above%2C%20airy%20bright%20composition%2C%20warm%20neutral%20cream%20and%20sand%20tones%2C%20editorial%20catalog%20photography%20style%20with%20gentle%20shadows%20and%20subtle%20textures%2C%20organized%20grid%20arrangement&width=1600&height=800&seq=showcase-products-vigorbuy-v2&orientation=landscape"
              alt="VigorBuy Spreadsheet product showcase - Modern collection with sweatshirts, sneakers, bags and accessories"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/20" />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
              <p className="text-xs md:text-sm font-label text-background-50/90 mb-2">Discover What Is Inside</p>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-background-50 mb-1">
                14 Organized Product Categories
              </h3>
              <p className="text-sm text-background-50/80 max-w-lg">
                From premium streetwear to essential accessories, browse through a carefully curated selection of products updated regularly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}